import { NavigationMenuItem } from '../interfaces/navigation-menu.interface';

export const navigationMenu: NavigationMenuItem[] = [
  {
    label: 'Inicio',
    url: '/'
  },
  {
    label: 'Servicios',
    url: 'servicios'
  },
  {
    label: 'Contacto',
    url: 'contacto'
  }
];
